import { render } from "./TornadoChart.vue?vue&type=template&id=570d63b5&scoped=true"
import script from "./TornadoChart.vue?vue&type=script&lang=js"
export * from "./TornadoChart.vue?vue&type=script&lang=js"

import "./TornadoChart.vue?vue&type=style&index=0&id=570d63b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570d63b5"]])

export default __exports__